import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bdktycs6: FaireBrandEntity = {
  token: "b_bdktycs6",
  type: "brand",
  name: "Na Nin",
  avatarUrl:
    "https://cdn.faire.com/fastly/1f2188e13729e060800c79cf647dba5c6bd5243303f45b9aae1553cd0316cbc1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/86b9402337350ed574f93d1309b64f79f0f067fa89883cd0536153aeb74233b3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1f2188e13729e060800c79cf647dba5c6bd5243303f45b9aae1553cd0316cbc1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/86b9402337350ed574f93d1309b64f79f0f067fa89883cd0536153aeb74233b3.png",
  location: "Richmond, VA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 17,
  isTopShop: true,
  isInsider: true,
  description:
    "ABOUT LEAD TIME: Apparel & accessories are in stock and ready to ship within 1 week. Fragrances are made to order and will ship in 3-4 weeks.\n\nABOUT OUR BRAND: In 2009 Na Nin established its roots in celebrating vintage clothing inspired by nostalgia and kindness. In 2014 Na Nin introduced a collection of signature fragrances inspired by music and personal memories, which has since grown into a full selection of perfumes, candles, and apothecary all hand blended in Richmond, VA. In 2017 Na Nin released a line of in house apparel created with the same intention and inspiration behind our curation of vintage. Made for more than a moment, our in house line consists of timeless pieces made to become forever keepsakes.\n\nABOUT EXCLUSIVITY: We are grateful for each of our wholesale partnerships. If you have concerns about exclusivity please don’t hesitate to reach out to us prior to placing your first order. If there are no active retailers already in your area, we offer exclusivity in your area with a commitment to ordering $3,500 yearly. As a retailer of other independent brands ourselves, we understand the importance of being able to curate special offerings for your community. As a small business reliant on sustainable growth, we hope you understand what we are able offer and accommodate within the limitations of this platform. We sincerely appreciate your patience with this process as we are navigating constantly changing needs to the best of our ability.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:22.972Z",
    importedBy: "entity-db-cli",
  },
};
